export const womenLevelTwo=[
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Indian & fusion Wear",
      "categoryId": "women_indian_and_fusion_wear"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"western wear",
      "categoryId": "women_western_wear"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Footwear",
      "categoryId": "women_footwear"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Sports & Active Wear",
      "categoryId": "women_sports_active_wear"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Lingerie Sleepwear",
      "categoryId": "women_lingerie_sleepwear"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Buauty & Personal Care",
      "categoryId": "women_beauty_personal_care"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Gadgets",
      "categoryId": "women_gadgets"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Jewellery",
      "categoryId": "women_jewellery"
    },
    {
      "parentCategoryId":"women",
      "level":2,
      "name":"Handbags, Bags & wallets",
      "categoryId": "women_handbags_bags_wallets"
    }
  ]
  